import * as Sentry from '@sentry/browser'

const DEPLOYED_ENVIRONMENTS = ['Test', 'Staging', 'production']

function beforeSend (event) {
  if (event.request) {
    delete event.request.cookies
    delete event.request.headers
  }
  return event
}

function initSentry () {
  if (typeof window !== 'undefined' && window.__SENTRY_INITIALIZED__) {
    return
  }

  const dsn = typeof SENTRY_DSN !== 'undefined' ? SENTRY_DSN : ''
  const environment = typeof SENTRY_ENVIRONMENT !== 'undefined' ? SENTRY_ENVIRONMENT : ''
  const release = typeof SENTRY_RELEASE !== 'undefined' ? SENTRY_RELEASE : ''

  if (!dsn || !environment || !DEPLOYED_ENVIRONMENTS.includes(environment)) {
    return
  }

  Sentry.init({
    dsn,
    environment,
    release: release || undefined,
    tracesSampleRate: 0,
    beforeSend,
    initialScope: {
      tags: { component: 'udc-legacy' }
    }
  })

  window.__SENTRY_INITIALIZED__ = true
}

initSentry()
